<template>
  <div class="addrecord">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'mydevice' }">我的设备</el-breadcrumb-item>
      <el-breadcrumb-item>添加记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider />
    <div class="main">
      <div class="fr ac mt20 add_cell">
        <p class="fs device_name need">记录类型:</p>
        <el-select v-model="value" placeholder="请选择" class="ml20 right" size="mini">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="fr ac mt20 add_cell" v-if="value == '1'">
        <p class="fs device_name need">产品编号:</p>
        <el-input
          :value="order_goods_no"
          placeholder="请选择"
          class="ml20 right"
          size="mini"
          @click.native="show = true"
        ></el-input>
      </div>
      <div class="fr ac mt20 add_cell">
        <p class="fs device_name need">日期:</p>
        <el-date-picker
          v-model="record_time"
          type="datetime"
          placeholder="选择日期时间"
          class="ml20 right"
          size="mini"
        ></el-date-picker>
      </div>
      <div class="fr ac mt20 add_cell" v-if="value == '2'">
        <p class="fs device_name need">记录内容:</p>
        <el-input
          type="textarea"
          v-model="record_desc"
          resize="none"
          class="ml20 right"
          size="mini"
          :rows="3"
        ></el-input>
      </div>
      <div class="fr ac add_cell" v-if="value == '2'">
        <p class="fs device_name">图片:</p>
        <up-load :file_list.sync="record_imgs" :limit="6" />
      </div>
      <div class="fr ac add_cell mt20">
        <p class="fs device_name"></p>
        <el-button type="primary" class="ml20" size="mini" @click="insertDeviceRecord">添加记录</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="show" :show-close="false">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择订单</p>
        <i class="el-icon-close fz14 cursor" @click="show = false"></i>
      </div>
      <div class="fr ac fz12 mt30">
        <div class="center order_list_item">选择</div>
        <div class="center order_list_item">产品信息</div>
        <div class="center order_list_item">产品规格</div>
        <div class="center order_list_item">设备信息</div>
        <!-- <div class="center order_list_item">配套工艺</div> -->
        <div class="center order_list_item">产品价格</div>
        <div class="center order_list_item">数量</div>
        <div class="center order_list_item">小计</div>
      </div>

      <!-- 列表-->
      <div class="order-list fz12" v-for="(item,index) in order_data" :key="index">
        <div
          class="order-item mt20"
          v-for="goods in item.orderGoodsBeans"
          :key="goods.order_goods_id"
        >
          <!--  上-->
          <div class="top">
            <span class="grey">订单编号：{{goods.order_goods_no}}</span>
          </div>
          <!--  中-->

          <!-- 商品信息 -->
          <div class="fr ac order">
            <div class="center order_list_item red">
              <el-radio
                class="radio"
                v-model="order_goods_id"
                :label="goods.order_goods_id"
                @click.once.native="rows(goods)"
              >&nbsp;</el-radio>
            </div>
            <div class="fr afs pl10 pr10 pt10 pb10 order_list_item">
              <el-image class="goods_img fs mr10" :src="goods.goods_img" alt />
              <p class>{{goods.goods_name}} {{goods.goods_standard_name}}</p>
            </div>
            <div class="center order_list_item"> {{ specNameInit(goods) }}</div>
            <div class="center order_list_item">{{goods.device_id?goods.device_id:'-'}}</div>

            <!-- <div class="center cursor order_list_item bule">
              {{goods.goods_type==1?
              "￥"+goods.goods_craft_price:'-'}}
            </div>-->
            <div class="center order_list_item">￥{{goods.goods_price}}</div>
            <div class="center order_list_item">{{goods.goods_num}}</div>
            <div class="center order_list_item red">￥{{goods.goods_actual_price}}</div>
          </div>
        </div>
      </div>
      <div class="fr ac jfe">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          class="mt20 mb20"
          background
          :hide-on-single-page="true"
        />
      </div>
      <div class="fr ac jc mt20">
        <el-button type="primary" @click="selectorders" size="mini">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UpLoad from "@/components/UploadImg";

export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "安装记录"
        },
        {
          value: "2",
          label: "保养记录"
        }
      ],
      order_goods_no: "",
      value: "1",
      record_time: "",
      show: false,
      record_desc: "",
      record_imgs: [],
      order_data: [],
      total: 0,
      page: 1,
      order_goods_id: ""
    };
  },
  created() {},
  watch: {
    show(n) {
      this.getOrders();
    },
    radio(n) {
      console.log(n);
    },
    page(n) {
      this.getOrders();
    }
  },
  methods: {
    rows(goods) {
      this.order_goods_no = goods.order_goods_no;
    },
    selectorders() {
      if (!this.order_goods_id) {
        this.$message({
          type: "warning",
          message: "未选择订单"
        });
        return;
      }
      this.show = false;
    },
    // 获取订单数据
    getOrders() {
      this.post("orderInterfaces/v1.0/getOrders", {
        page: this.page,
        pay_state: "2,3",
        send_state: "3,4"
      }).then(res => {
        if (res.status == "ok") {
          this.total = res.total;
          this.order_data = res.data;
        }
      });
    },
    // 添加记录
    insertDeviceRecord() {
      if (this.value == "1") {
        if (!this.order_goods_id) {
          this.$message({
            type: "warning",
            message: "未选择产品编号"
          });
          return;
        }
      } else {
        if (!this.record_desc) {
          this.$message({
            type: "warning",
            message: "未填写保养内容"
          });
          return;
        }
      }
      if (!this.record_time) {
        this.$message({
          type: "warning",
          message: "未选择日期"
        });
        return;
      }
      let obj = {};
      obj.record_type = this.value;
      if (this.value == "1") {
        obj.order_goods_id = this.order_goods_id;
        obj.order_goods_no = this.order_goods_no;
      } else {
        obj.record_desc = this.record_desc;
        obj.record_imgs = this.record_imgs.join(",");
      }
      obj.company_device_id = this.$route.query.id;
      obj.record_time = this.conversion(this.record_time);
      this.post("companyInterfaces/v1.0/insertCompanyDeviceRecord", obj).then(
        res => {
          this.$message({
            type: "success",
            message: res.data
          });
        }
      );
    }
  },
  components: { "up-load": UpLoad }
};
</script>

<style lang="scss">
.addrecord {
  font-size: 14px;
  .add_cell {
    .device_name {
      width: 100px;
      text-align: right;
    }
    .right {
      width: 30%;
    }
  }
  .el-dialog {
    width: 1000px;
    .el-dialog__header {
      background-color: #eaeaea;
      height: 40px;
      padding: 0 20px;
      .head {
        height: 100%;
      }
    }
    .el-dialog__body {
      height: 70%;
      overflow-y: scroll;
      .order_list_item {
        &:nth-of-type(1) {
          width: 88px;
        }
        &:nth-of-type(2) {
          width: 270px;
        }
        &:nth-of-type(3) {
          width: 88px;
        }
        &:nth-of-type(4) {
          width: 110px;
        }
        &:nth-of-type(5) {
          width: 88px;
        }
        &:nth-of-type(6) {
          width: 88px;
        }
        &:nth-of-type(7) {
          width: 196px;
        }
        &:nth-of-type(8) {
          width: 88px;
        }
      }
      .order-list {
        .order-item {
          border: 1px solid #e5e5e5;
          .top {
            background-color: #f0f6ff;
            padding: 14px;
          }
          .order {
            width: 100%;
            &:last-child {
              border-bottom: none;
            }
            .goods_img {
              width: 40px;
              height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/addRecord.vue